module.exports = __webpack_public_path__ + "img/related_thumb_01.c4a7f4e3.png";